import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { IoCloseOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import CommonOpacityBackground from "../../components/Common/commonOpacityBackground";
import { useEffect, useMemo, useState } from "react";
import { COMMON_WEB_PATH } from "../../constant";
import { useTranslation } from "react-i18next";
import { isValidMotionProp, motion } from "framer-motion";
import useSubTypeList from "../../hook/useSubTypeList";
import useSpecPath from "../../hook/useSpecPath";
import useCasinoType from "../../hook/useCasinoType";
import { filterType } from "../../hook/useGameListFilter";
import { BsTools } from "react-icons/bs";
import LazyImage from "../../components/Loading/lazyImage";
import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  chakra,
  shouldForwardProp,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { IoLogoGameControllerB } from "react-icons/io";
import { Link } from "react-router-dom";
import { thisImageNeedDark } from "../../utils/thisImageNeedDark";
import useGetFullGamePlatform from "../../hook/useGetFullGamePlatform";
import { popFromBottom } from "../../animateConstant";
import { routeMapping } from "../../components/GameComponents/GameTypeSelector/utils/routeMapping";
import useLongMachineSetting from "../../hook/useLongMachineSetting";
import GameSearchContent from "../../components/LayoutComponents/HeaderComponents/GameSearchContent";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const CasinoGroups = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [search, setSearch] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const { colorMode, toggleColorMode } = useColorMode();

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);

  const boxBg = useColorModeValue("#efeff6", "#262d47");
  const textColor = useColorModeValue("dark.100", "light.100");
  const itemBg = useColorModeValue("light.100", "#46507A");
  const borderColor = useColorModeValue("#CBCBCE", "#46507A");

  const casinoType = useCasinoType();

  const {
    allGamePlatform = [],
    sortedByPlatformGames = {},
    sortedByPlatformAndCategoryGames = {},
    platform = [],
    gameList = [],
  } = isHandleAllGame;

  const subTypeList = useSubTypeList({ forceShowAll: true });

  const filterPlatformBySubType = useMemo(() => {
    const filterNullGame = Object.keys(sortedByPlatformAndCategoryGames).filter(
      (key) =>
        Object.keys(sortedByPlatformAndCategoryGames[key]).some((k) =>
          subTypeList.includes(k),
        ),
    );
    const list = filterNullGame.map((item) => {
      const listLengthBigThanOne =
        filterType({
          gameList: sortedByPlatformGames[item],
          casinoType: casinoType,
        })?.length > 0;

      if (!listLengthBigThanOne) {
        return;
      } else {
        return item;
      }
      // return item;
    });

    return list;
  }, [subTypeList]);

  const handleInput = (e) => {
    setSearch(e.target.value);
  };

  const getPlatformPath = useGetFullGamePlatform();

  // const casinoGroup = useMemo(() => {
  //   if (casinoType === "promotion") {
  //     return platform;
  //   }
  //   if (search) {
  //     return filterPlatformBySubType.filter((item) => {
  //       return item?.toLowerCase()?.includes(search);
  //     });
  //   } else {
  //     return filterPlatformBySubType;
  //   }
  // }, [search, filterPlatformBySubType, casinoType]);

  // const casinoGroup = useMemo(() => {
  //   return gameList;
  // }, [gameList]);

  // 過濾掉 EGAME, TABLE, SPORT
  const filteredCasinoGroups = useMemo(() => {
    const excludedTypes = ["EGAME", "TABLE"];

    if (!gameList) return {};

    return Object.keys(gameList).reduce((acc, gameType) => {
      if (!excludedTypes.includes(gameType)) {
        acc[gameType] = gameList[gameType];
      }
      return acc;
    }, {});
  }, [gameList]);

  const casinoGroup = filteredCasinoGroups;

  const { longMachinePaddingTop } = useLongMachineSetting();

  const handleClose = () => {
    let origin = location.state?.from?.pathname || "/";
    // 雙重保險：避免 origin 剛好是搜尋頁自己
    if (origin.includes("casino-group")) {
      origin = location.state?.from?.pathname || "/";
    }
    navigate(origin);
  };

  return (
    <CommonOpacityBackground
      className={"lg:backdrop-blur-none backdrop-blur-md pt-[100px]"}
      path={handleClose}
    >
      <ChakraBox
        onClick={(e) => {
          e.stopPropagation();
        }}
        pt={longMachinePaddingTop}
        {...popFromBottom}
        minH={{
          md: "248px",
        }}
        maxH={{
          md: "calc(100vh - 92px)",
        }}
        w={{
          base: "100%",
          md: "720px",
        }}
        h="100%"
        overflow="hidden"
        bg={boxBg}
        borderTopRadius={{
          base: `24px`,
        }}
        borderBottomRadius={{
          md: `24px`,
        }}
        gap="30px"
        px="15px"
        display="flex"
        flexDirection={`column`}
        className="no-scrollbar"
      >
        <Box pt="20px" display="flex" justifyContent={`space-between`}>
          <Text
            fontSize="20px"
            fontWeight={`medium`}
          >{`${i18n("Search")}`}</Text>
          <Box onClick={handleClose}>
            <Icon cursor={`pointer`} fontSize="30px" as={IoCloseOutline} />
          </Box>
        </Box>
        <Tabs flex={1} display="flex" flexDirection="column" overflow="hidden">
          <TabList>
            <Tab>{t("common.搜尋遊戲")}</Tab>
            <Tab>{t("common.供應商")}</Tab>
          </TabList>

          <TabPanels flex={1} overflow="hidden">
            <TabPanel h="100%" p={0}>
              <GameSearchContent />
            </TabPanel>
            <TabPanel h="100%" overflowY="auto">
              {Object.keys(casinoGroup || {}).map((gameType) => {
                return (
                  <Box>
                    <Flex gap="5px">
                      <Text fontSize="16px" fontWeight={`700`} mb="10px">
                        {i18n(gameType)}
                      </Text>
                      <Image
                        src={`${COMMON_WEB_PATH}/FlyDragon/game-type-icon/${gameType?.toUpperCase()}Pic.webp`}
                        w="27px"
                        h="27px"
                      />
                    </Flex>
                    <Box
                      display="grid"
                      gap="10px"
                      className="grid-cols-2 md:grid-cols-4"
                    >
                      {Object.keys(casinoGroup[gameType] || {})?.map(
                        (plat, index) => {
                          const platConfig = allGamePlatform;
                          const isMaintain =
                            platConfig?.isUnderMaintenance === true;
                          const getGameType = routeMapping(gameType);
                          return (
                            plat && (
                              <Box
                                onClick={() => {
                                  if (isMaintain) {
                                    return;
                                  }
                                  navigate(
                                    `${getGameType?.link}/category/${plat}/AllGames`,
                                  );
                                }}
                                key={`${plat}-${index}`}
                                bg={itemBg}
                                cursor={`pointer`}
                                h="100px"
                                borderRadius={`common`}
                                px="7px"
                                display="flex"
                                flexDirection={`column`}
                                alignItems={`center`}
                                justifyContent={`center`}
                                border="1px solid"
                                borderColor={borderColor}
                                _hover={{
                                  border: "1px solid",
                                  borderColor: "brand.500",
                                }}
                                position="relative"
                              >
                                {isMaintain && (
                                  <Box
                                    zIndex="2"
                                    position={`absolute`}
                                    top="0"
                                    left="0"
                                    w="full"
                                    h="full"
                                    bg="rgba(0,0,0,0.7)"
                                    display="flex"
                                    alignItems={`center`}
                                    justifyContent={`center`}
                                    flexDirection={`column`}
                                  >
                                    {" "}
                                    <BsTools className="text-2xl" />
                                    <Text
                                      as="span"
                                      fontSize="sm"
                                      letterSpacing={`tighter`}
                                    >
                                      {platConfig?.maintenanceStartTime || "-"}{" "}
                                      ~
                                    </Text>
                                    <Text
                                      as="span"
                                      fontSize="sm"
                                      letterSpacing={`tighter`}
                                    >
                                      {platConfig?.maintenanceEndTime || "-"}
                                    </Text>
                                  </Box>
                                )}

                                <LazyImage
                                  className="mx-auto w-[100px] h-[55px] object-contain"
                                  src={`${COMMON_WEB_PATH}/ds88platformIcon/${thisImageNeedDark(
                                    plat.replace(/\s+/g, ""), // 移除所有空格
                                    colorMode === "dark",
                                  )}.png`}
                                  alt={plat}
                                />
                                <Text>{plat}</Text>
                              </Box>
                            )
                          );
                        },
                      )}
                    </Box>
                  </Box>
                );
              })}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </ChakraBox>
    </CommonOpacityBackground>
  );
};

export default CasinoGroups;
